import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormThingsToImprove } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getJbpKeyInitiativeCrud = () =>
  CrudStore.get(
    CrudStoreItemPartner360.JBPSPKeyInitiatives,
    'JBBCategory'
  ) as Crud<IFormThingsToImprove>
